import { send_request } from "../../../utils/Request";

export async function sendManagedRunRequest(path, body, query, method) {
  const response = await send_request(path, body, query, method);
  if (isReturnedRequestError(response)) {
    throw response;
  }
  return response;
}

function isReturnedRequestError(response) {
  return Boolean(
    response?.response ||
      response?.isAxiosError ||
      response?.status >= 400 ||
      (response?.message && response?.data === undefined)
  );
}

export async function getManagedRunForWorkflowSession(workflowSessionId) {
  return sendManagedRunRequest(
    `project-service/agent/managed-run/workflow-session/${workflowSessionId}`,
    null,
    null,
    "GET"
  );
}

export async function attachManagedRun(projectId, projectSessionId) {
  return sendManagedRunRequest(
    `project-service/project-session/${projectSessionId}/managed-run/attach`,
    null,
    { projectId },
    "POST"
  );
}

export async function stopManagedRun(
  chatSessionId,
  reason = "Stopped by user"
) {
  return sendManagedRunRequest(
    `project-service/agent/session/${chatSessionId}/managed-run/stop`,
    { reason },
    null,
    "POST"
  );
}

export async function applyLatestManagedRunPolicy(projectId, projectSessionId) {
  return sendManagedRunRequest(
    `project-service/project-session/${projectSessionId}/managed-run/apply-latest-policy`,
    null,
    { projectId },
    "POST"
  );
}

export async function updateManagedRunPolicy(projectId, policy) {
  return sendManagedRunRequest(
    `project-service/project/managed-run-policy/${projectId}`,
    policy,
    null,
    "PATCH"
  );
}
